import SvgPlay from '@sats-group/icons/24/play';
import Text from '@sats-group/ui-lib/react/text';
import cn from 'classnames';
import React, { useRef, useState } from 'react';
import type { VideoBlock as Props } from './video-block.types';

const VideoBlock: React.FC<Props> = ({
  description,
  eyebrow,
  playLabel,
  title,
  video,
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [hasStarted, setHasStarted] = useState(false);

  const play = () => {
    if (!videoRef.current) {
      return;
    }

    setHasStarted(true);
    videoRef.current.play().catch(() => setHasStarted(false));
  };

  return (
    <section className="video-block">
      <div className="video-block__header">
        {eyebrow ? (
          <Text
            className="video-block__eyebrow"
            size={Text.sizes.basic}
            theme={Text.themes.normal}
          >
            {eyebrow}
          </Text>
        ) : null}
        <Text
          className="video-block__title"
          elementName="h2"
          size={Text.sizes.headline1}
          theme={Text.themes.emphasis}
        >
          {title}
        </Text>
        {description ? (
          <Text
            className="video-block__description"
            elementName="p"
            size={Text.sizes.basic}
          >
            {description}
          </Text>
        ) : null}
      </div>
      <div
        className={cn('video-block__player', {
          'video-block__player--started': hasStarted,
        })}
      >
        <video
          aria-label={video.text || title}
          className="video-block__video"
          controls={hasStarted}
          onEnded={() => setHasStarted(false)}
          playsInline
          preload="metadata"
          ref={videoRef}
        >
          <source src={`${video.source}#t=0.1`} type={video.type} />
        </video>
        {hasStarted ? null : (
          <button
            aria-label={playLabel}
            className="video-block__overlay"
            onClick={play}
            type="button"
          >
            <span className="video-block__play">
              <SvgPlay />
            </span>
          </button>
        )}
      </div>
    </section>
  );
};

export default VideoBlock;
